export default {
    create : {title : "🛠️ Create a new Dashboard", send : "Create"},
    update : {title : "🛠️ Update your Dashboard",  send : "Update"}
}